import client from './api-client'
import config from "../config";

const localStorageKeyAuthToken = process.env.REACT_APP_AUTH_TOKEN_KEY
const localStorageKeyKundeneinstellungen = process.env.REACT_APP_KUNDENEINSTELLUNG_KEY

function handleUserResponse({id, kundennummer, kundeneinstellungen}) {
    window.localStorage.setItem(localStorageKeyAuthToken, id)
    window.localStorage.setItem(localStorageKeyKundeneinstellungen, JSON.stringify(kundeneinstellungen))
    let user = kundennummer
    return user
}

function getUser(kundennummer) {
    const token = getToken()
    if (!token || !kundennummer) {
        clearKundeneinstellungen()
        clearToken()
        return Promise.resolve(null)
    }
    return client(`${config.conf_backend_api}/kunde/${kundennummer}`).catch(error => {
        logout()
        return Promise.reject(error)
    })
}

function login({username, password}) {
    return client(`${config.conf_backend_api}/kundenlogin`, {
        body: {
            login: username,
            passwort: password
        }
    }).then(handleUserResponse)
}

function logout() {
    return client(`${config.conf_backend_api}/kundenabmeldung`).then(() => {
        window.localStorage.removeItem(localStorageKeyAuthToken)
        window.localStorage.removeItem(localStorageKeyKundeneinstellungen)
    })
}

function clearToken() {
    window.localStorage.removeItem(localStorageKeyAuthToken)
}

function clearKundeneinstellungen() {
    window.localStorage.removeItem(localStorageKeyKundeneinstellungen)
}

function getToken() {
    return window.localStorage.getItem(localStorageKeyAuthToken)
}

function getKundeneinstellungen() {
    return JSON.parse(window.localStorage.getItem(localStorageKeyKundeneinstellungen))
}

export {login, logout, getToken, clearToken, getUser, clearKundeneinstellungen, getKundeneinstellungen}